<template>
  <div class="dod18" ref="dod18">
    <div class="dod16_title">Circle</div>
  </div>
</template>

<script>
import { Particle } from '@/modules/day18-particle'

export default {
  name: 'Day18',

  data: () => ({
    pixi: false
  }),

  beforeDestroy() {
    if (this.pixi) {
      this.pixi.destroy()
    }
  },

  mounted() {
    const el = this.$refs.dod18
    this.pixi = new Particle(el)
  }
}
</script>

<style scoped lang="scss">
.dod18 {
  @include FR_FULLSIZE;
  overflow: hidden;
  background: top 100% right 100% no-repeat, linear-gradient(hsla(215,75%,25%,1), #1561a4 33.19%, #195691 81.51%, hsla(212,74%,30%,1));
}
.dod16_title {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center);
  @include WEBFONT(normal, 800);
  font-style: italic;
  color: #ffffff;
  font-size: 10vw;
  font-weight: bold;
}
</style>
